import React from 'react'
import { Alert } from '@mui/material'
import { useAppSelector } from 'utils/custom-hooks/useTypedReduxStore'
import { formatNumber } from 'utils/helpers'

interface WeightThresholdError {
  commodityId: string
  commodityName: string
  threshold: number
  weight: number
}

interface CommodityWeightThresholdAlertProps {
  weightThresholdErrors: WeightThresholdError[]
}

const CommodityWeightThresholdAlert: React.FC<CommodityWeightThresholdAlertProps> = ({ weightThresholdErrors }) => {
  const { defaultYardUm } = useAppSelector(state => state.settings)

  return (
    <Alert severity="error" sx={{ mb: 2 }}>
      This ticket is over the weight threshold for the following commodities:
      <ul style={{ margin: 0 }}>
        {weightThresholdErrors.map(weightThresholdError => (
          <li key={`commodity-weight-threshold-${weightThresholdError.commodityId}`}>
            {`${weightThresholdError.commodityName} (Allowed: ${formatNumber(weightThresholdError.threshold)} ${defaultYardUm}, Current: ${formatNumber(weightThresholdError.weight)} ${defaultYardUm})`}
          </li>
        ))}
      </ul>
    </Alert>
  )
}

export default CommodityWeightThresholdAlert
